import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.446 9.967C-.85 8.69.965 6.674 2.262 7.884l2.917 2.823 8.56-8.335c1.296-1.21 3.112.807 1.815 2.084l-9.467 9.14c-.519.538-1.297.538-1.815 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }